import React from 'react';
import {
  Container,
} from '@mui/material';
import Card from '../../UI/Cards/ActionCardTimeline';
import Spinner from '../Spinner/index';

function ActionsTimeline({ data, spinner, handleAction }) {
  return (
    <>
      <Container>
        <div style={{ ...styles.cardsContainer, marginTop: data ? '4rem': 0 }}>
          {data && data.map((doc, index) => (
            <Card
              index={index}
              click={() => handleAction(doc._id)}
              key={doc._id}
              {...doc}
            />
          ))}
        </div>
      </Container>
    </>
  );
}

export default ActionsTimeline;

const styles = {
  card: {

  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '20px 0',
    color: 'grey',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 15px',
  },
  list: {
    maxHeight: 300,
    overflowY: 'auto',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    cursor: 'pointer',
  },
  label: {
    color: 'grey',
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 25,
  },
};
